import { createFileRoute } from '@tanstack/react-router'
import { PartnerDashboard } from '../../../components/PartnerDashboard'
import { useOrganization } from '@/hooks/useOrganization'
import { PartnerOrgTypeContext } from '@/hooks/usePartnerTar'

export const Route = createFileRoute('/admin/organizations/assignments/$organizationId')({
  component: AdminOrganizationAssignmentsPage,
})

function AdminOrganizationAssignmentsPage() {
  const { organizationId } = Route.useParams()
  // Admins have no organizationType of their own, so tP would fall back to company
  // copy — resolve the viewed org's type so school orgs read students/classes.
  const { organization } = useOrganization(organizationId)
  return (
    <PartnerOrgTypeContext.Provider value={organization?.type}>
      <PartnerDashboard organizationId={organizationId} />
    </PartnerOrgTypeContext.Provider>
  )
}
